import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  actionPath?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  actionLabel,
  actionPath,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div
      className={`flex flex-col gap-4 mb-8 md:mb-10 ${
        isCenter ? "items-center text-center" : "md:flex-row md:items-end md:justify-between"
      }`}
    >
      <div className={isCenter ? "max-w-2xl" : "max-w-2xl"}>
        {eyebrow ? <span className="section-eyebrow">{eyebrow}</span> : null}
        <h2 className="mt-2 text-2xl md:text-4xl text-foreground-950 text-balance">{title}</h2>
        {desc ? <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p> : null}
      </div>
      {actionLabel && actionPath ? (
        <Link
          to={actionPath}
          className="inline-flex items-center gap-1.5 self-start md:self-auto text-sm font-medium text-primary-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
        >
          <span>{actionLabel}</span>
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </Link>
      ) : null}
    </div>
  );
}